import { render } from "./document.ic.vue?vue&type=template&id=6df7a857"
import script from "./document.ic.vue?vue&type=script&lang=js"
export * from "./document.ic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__